
interface CustomCountIconProps {
    content: number | string
}

export const CustomCountIcon: React.FC<CustomCountIconProps> = ({ content }) => {
    const contentString = content.toString()
    const charCount = contentString.length
    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "20px", width: "20px", borderRadius: "50%", backgroundColor: "#D1031C" }}>
            <span style={{ color: "white", fontSize: ".6rem" }}>{
                charCount > 3
                    ? `~${contentString[0]}k`
                    : content
            }</span>
        </div>
    )
}